import { COUNTRIES } from '~constants/environment';

export const tipType = {
  customText: 'customText',
  percentage: 'percentage',
  customInput: 'customInput'
};

export const DEFAULT_TIP_OPTION = 1;

export const KEY_WITHOUT_TIP = 'without-tip';
export const KEY_INPUT_TIP = 'input-tip';

export const TOTAL_CONDITION = 20000;

const TIPS_DEFAULT = [
  {
    id: 'percentage-10',
    index: 1,
    percentage: 10,
    canRenderCondition: false
  },
  {
    id: 'percentage-20',
    index: 2,
    percentage: 20,
    canRenderCondition: false
  },
  {
    id: 'percentage-30',
    index: 3,
    percentage: 30,
    canRenderCondition: false
  }
];

export const TIPS_BY_COUNTRIES = {
  [COUNTRIES.cl]: {
    enable: true,
    limitAmount: 20000,
    tipOptions: [
      {
        id: 'percentage-1000',
        index: 1,
        amount: 1000,
        canRenderCondition: true,
        renderWithTotalValidation: total => total < TIPS_BY_COUNTRIES[COUNTRIES.cl].limitAmount
      },
      {
        id: 'percentage-5',
        index: 1,
        percentage: 5,
        canRenderCondition: true,
        renderWithTotalValidation: total => total > TIPS_BY_COUNTRIES[COUNTRIES.cl].limitAmount
      },
      {
        id: 'percentage-10',
        index: 2,
        percentage: 10,
        canRenderCondition: false
      },
      {
        id: 'percentage-15',
        index: 3,
        percentage: 15,
        canRenderCondition: false
      }
    ],
    tipByDefault: DEFAULT_TIP_OPTION
  },
  [COUNTRIES.es]: {
    enable: true,
    enableRenderCondition: false,
    tipOptions: [...TIPS_DEFAULT],
    tipByDefault: KEY_WITHOUT_TIP
  },
  [COUNTRIES.pt]: {
    enable: true,
    enableRenderCondition: false,
    tipOptions: [...TIPS_DEFAULT],
    tipByDefault: KEY_WITHOUT_TIP
  },
  [COUNTRIES.pa]: {
    enable: true,
    enableRenderCondition: false,
    tipOptions: [...TIPS_DEFAULT],
    tipByDefault: DEFAULT_TIP_OPTION
  },
  [COUNTRIES.cr]: {
    enable: true,
    enableRenderCondition: false,
    tipOptions: [...TIPS_DEFAULT],
    tipByDefault: DEFAULT_TIP_OPTION
  },
  [COUNTRIES.gt]: {
    enable: true,
    enableRenderCondition: false,
    tipOptions: [...TIPS_DEFAULT],
    tipByDefault: DEFAULT_TIP_OPTION
  }
};
